import React, { useEffect, useState } from "react";
import Topbar from "../../Component/Topbar/Topbar";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { blue, green, orange, person, pink, red } from "../../assets/img";
import { useForm, Controller, set } from "react-hook-form";
import { get, post } from "../redux/api/ApiHandler";
import { URLS } from "../redux/api/Constants";
import SelectBox from "../../Component/SelectBox";

const Dashboard = () => {
  const [userList, setUserList] = useState();
  const [overallList, setOverallList] = useState();
  const [regionList, setRegionList] = useState([]);
  const [allRegionList, setAllRegionList] = useState(0);
  const [regionOptions, setRegionOptions] = useState([]);
  const [customerList, setCustomerList] = useState();
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);

  const {
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      CouponType: null,
    },
  });

  const dashboardList = async (val) => {
    // console.log("val", val);
    setSelected(val);
    let payload = {
      region_id: val?.value,
    };

    let res = await post(URLS.DASHBOARD_LIST, payload);
    if (res?.status == "success") {
      setCustomerList(res?.customer_count);
      setOverallList(res?.overall_ticket);
      if (res?.selected_region_summary != null) {
        setRegionList(res?.selected_region_summary);
        setAllRegionList(1);
      } else {
        setUserList(res?.user_summary);
        setRegionList(res?.overall_ticket);
        setAllRegionList(res?.user_summary?.regional_manager);
      }
      setPagination(res?.pagination_meta);
    }
  };

  const regionDrop = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);
    }
  };

  useEffect(() => {
    dashboardList();
    regionDrop();
  }, []);

  return (
    <>
      <Topbar header={"Dashboard"} />
      <div className="container_fluit">
        <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24 px-3 py-3">
          Overall Summary
        </h4>
        <p className="f3 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20 my-3 px-3 ">
          User List
        </p>
        <div className="row mt-4 px-3 py-3 gap-3 mx-0">
          <div
            className="col-sm-4 col-md-2 dash-boxes mb-3  text-center  dashboard-title "
            style={{
              backgroundColor: "#DBF0FF",
            }}
          >
            <p
              className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
              style={{ whiteSpace: "normal" }}
            >
              Super Admin
            </p>
            <div className="d-flex ac-jc gap-2">
              <img src={blue} alt="icon" height={20} />
              <h5
                className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                style={{ color: "#1A77BC" }}
              >
                {userList?.super_admin ?? "-"}
              </h5>
            </div>
          </div>
          <div
            className="col-sm-4 col-md-2 dash-boxes mb-3 text-center  dashboard-title "
            style={{
              backgroundColor: "#EAF7EC",
            }}
          >
            <p
              className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
              style={{ whiteSpace: "normal" }}
            >
              Inventory
            </p>
            <div className="d-flex ac-jc gap-2">
              <img src={green} alt="icon" height={20} />
              <h5
                className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                style={{ color: "#2E7D32" }}
              >
                {userList?.inventory ?? "-"}
              </h5>
            </div>
          </div>
          <div
            className="col-sm-4 col-md-2 dash-boxes mb-3 text-center  dashboard-title "
            style={{
              backgroundColor: "#FFF4E5",
            }}
          >
            <p
              className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
              style={{ whiteSpace: "normal" }}
            >
              Technical
            </p>
            <div className="d-flex ac-jc gap-2">
              <img src={orange} alt="icon" height={20} />
              <h5
                className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                style={{ color: "#E65100" }}
              >
                {userList?.technical ?? "-"}
              </h5>
            </div>
          </div>
          <div
            className="col-sm-4 col-md-2 dash-boxes mb-3 text-center  dashboard-title "
            style={{
              backgroundColor: "#FFF0F3",
            }}
          >
            <p
              className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
              style={{ whiteSpace: "normal" }}
            >
              Service Engineer
            </p>
            <div className="d-flex ac-jc gap-2">
              <img src={red} alt="icon" height={20} />
              <h5
                className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                style={{ color: "#C62828" }}
              >
                {userList?.service_engineer ?? "-"}
              </h5>
            </div>
          </div>
          <div
            className="col-sm-4 col-md-2 dash-boxes mb-3 text-center  dashboard-title "
            style={{
              backgroundColor: "#E8EAF6",
            }}
          >
            <p
              className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
              style={{ whiteSpace: "normal" }}
            >
              Regional Manager
            </p>
            <div className="d-flex ac-jc gap-2">
              <img src={blue} alt="icon" height={20} />
              <h5
                className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                style={{ color: "#1A77BC" }}
              >
                {userList?.regional_manager ?? "-"}
              </h5>
            </div>
          </div>
          <div
            className="col-sm-4 col-md-2 dash-boxes mb-3 text-center  dashboard-title"
            style={{
              backgroundColor: "#F9EBFF",
            }}
          >
            <p
              className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
              style={{ whiteSpace: "normal" }}
            >
              Customers
            </p>
            <div className="d-flex ac-jc gap-2">
              <img src={pink} alt="icon" height={20} />
              <h5
                className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                style={{ color: "#B832F4" }}
              >
                {customerList ?? "-"}
              </h5>
            </div>
          </div>
        </div>
        <div className="ticket_overll pt-4 pb-3 px-3 py-3">
          <p className="f3 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20 my-3">
            Overall Ticket
          </p>
          <div className="d-flex flex-wrap ac-jb mt-4  py-3 gap-3 mx-0">
            <div
              className="col-sm-4 col-md-3 dash-boxes mb-3  text-center  dashboard-title"
              style={{
                backgroundColor: "#fff",
              }}
            >
              <p
                className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19"
                style={{ whiteSpace: "normal" }}
              >
                New Ticket
              </p>
              <div className="d-flex ac-jc gap-2">
                <img src={blue} alt="icon" height={20} />
                <h5
                  className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                  style={{ color: "#1A77BC" }}
                >
                  {overallList?.new_ticket}
                </h5>
              </div>
            </div>
            <div
              className="col-sm-4 col-md-3 dash-boxes mb-3 text-center  dashboard-title"
              style={{
                backgroundColor: "#fff",
              }}
            >
              <p
                className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19"
                style={{ whiteSpace: "normal" }}
              >
                Pending Ticket
              </p>
              <div className="d-flex ac-jc gap-2">
                <img src={orange} alt="icon" height={20} />
                <h5
                  className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                  style={{ color: "#E65100" }}
                >
                  {overallList?.pending_ticket}
                </h5>
              </div>
            </div>
            <div
              className="col-sm-4 col-md-3 dash-boxes mb-3 text-center  dashboard-title"
              style={{
                backgroundColor: "#fff",
              }}
            >
              <p
                className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19"
                style={{ whiteSpace: "normal" }}
              >
                Work Completed
              </p>
              <div className="d-flex ac-jc gap-2">
                <img src={blue} alt="icon" height={20} />
                <h5
                  className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                  style={{ color: "#1A77BC" }}
                >
                  {overallList?.work_completed}
                </h5>
              </div>
            </div>
            <div
              className="col-sm-4 col-md-3 dash-boxes mb-3 text-center dashboard-title"
              style={{
                backgroundColor: "#fff",
              }}
            >
              <p
                className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
                style={{ whiteSpace: "normal" }}
              >
                Ticket Closed
              </p>
              <div className="d-flex ac-jc gap-2">
                <img src={pink} alt="icon" height={20} />
                <h5
                  className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                  style={{ color: "#B832F4" }}
                >
                  {overallList?.ticket_closed}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-4 pb-3 px-3 py-3">
          <div className="d-flex ac-jb">
            <p className="f3 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20 my-3">
              Region Based Summary
            </p>
            <div className="col-md-5">
              <Controller
                control={control}
                name="CouponType"
                rules={{ required: "Coupon Type is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Region
                    </label>
                    <SelectBox
                      options={regionOptions}
                      selected={selected}
                      setSelected={(val) => dashboardList(val)}
                    />
                    {errors.CouponType && (
                      <p style={{ color: "red" }}>
                        {errors.CouponType.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
          </div>
          <div className="d-flex ac-js gap-5 mt-4">
            <div className="region-card d-flex ac-jc gap-3 p-2">
              <img src={person} height={45} alt="" />
              <div>
                <h6 className="f1 fs-xs-15 fs-sm-15 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-19 mb-0">
                  Regional Manager
                </h6>
                <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 mb-0">
                  {allRegionList ? allRegionList : "-"}
                </p>
              </div>
            </div>
            <div className="region-card d-flex ac-jc gap-3 p-2">
              <img src={person} height={45} alt="" />
              <div>
                <h6 className="f1 fs-xs-15 fs-sm-15 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-19 mb-0">
                  Service Engineer
                </h6>
                <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 mb-0">
                  {regionList?.service_engineer_count ? regionList?.service_engineer_count : userList?.regional_manager ? userList?.regional_manager : "-"}
                </p>
              </div>
            </div>
            <div className="region-card d-flex ac-jc gap-3 p-2">
              <img src={person} height={45} alt="" />
              <div>
                <h6 className="f1 fs-xs-15 fs-sm-15 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-19 mb-0">
                  Customer
                </h6>
                <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 mb-0">
                  {regionList?.customer_count ? regionList?.customer_count : customerList ? customerList : "-"}
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-4 px-3 py-3 ac-jb mx-0">
            <div
              className="col-sm-4 col-md-3 dash-boxes mb-3  text-center  dashboard-title "
              style={{
                backgroundColor: "#DBF0FF",
              }}
            >
              <p
                className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
                style={{ whiteSpace: "normal" }}
              >
                New Ticket
              </p>
              <div className="d-flex ac-jc gap-2">
                <img src={blue} alt="icon" height={20} />
                <h5
                  className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                  style={{ color: "#1A77BC" }}
                >
                  {regionList?.new_ticket ?? "-"}
                </h5>
              </div>
            </div>

            <div
              className="col-sm-4 col-md-3 dash-boxes mb-3 text-center  dashboard-title "
              style={{
                backgroundColor: "#FFF4E5",
              }}
            >
              <p
                className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
                style={{ whiteSpace: "normal" }}
              >
                Pending Ticket
              </p>
              <div className="d-flex ac-jc gap-2">
                <img src={orange} alt="icon" height={20} />
                <h5
                  className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                  style={{ color: "#E65100" }}
                >
                  {regionList?.pending_ticket ?? "-"}
                </h5>
              </div>
            </div>
            <div
              className="col-sm-4 col-md-3 dash-boxes mb-3 text-center  dashboard-title "
              style={{
                backgroundColor: "#FFF0F3",
              }}
            >
              <p
                className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
                style={{ whiteSpace: "normal" }}
              >
                Work Completed
              </p>
              <div className="d-flex ac-jc gap-2">
                <img src={red} alt="icon" height={20} />
                <h5
                  className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                  style={{ color: "#C62828" }}
                >
                  {regionList?.work_completed ?? "-"}
                </h5>
              </div>
            </div>
            <div
              className="col-sm-4 col-md-3 dash-boxes mb-3 text-center  dashboard-title "
              style={{
                backgroundColor: "#E8EAF6",
              }}
            >
              <p
                className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
                style={{ whiteSpace: "normal" }}
              >
                Ticket Closed
              </p>
              <div className="d-flex ac-jc gap-2">
                <img src={blue} alt="icon" height={20} />
                <h5
                  className="f3 fs-xs-16 fs-sm-18 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28 mb-0"
                  style={{ color: "#1A77BC" }}
                >
                  {regionList?.ticket_closed ?? "-"}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
